/**
 * Equal Housing Opportunity Icon
 * 
 * Simple house symbol for Equal Housing Opportunity compliance.
 * For the full Fair Housing logo with text, use FairHousingIcon.
 */

import type { IconProps } from '../../types';

export function EqualHousingIcon({ 
  className, 
  size = 24, 
  color = 'currentColor',
  'aria-label': ariaLabel = 'Equal Housing Opportunity',
  ...props
}: IconProps) {
  return (
    <svg 
      className={className}
      width={size} 
      height={size}
      viewBox="0 0 24 24"
      fill={color}
      aria-label={ariaLabel}
      role="img"
      {...props}
    >
      <path d="M12 3L2 12h3v9h14v-9h3L12 3zm0 2.84L18 11v8H6v-8l6-5.16zM8 13h8v2H8v-2zm0 3h8v2H8v-2z" />
    </svg>
  );
}

